<template>
  <v-card elevation="1" class="transport" style="width: 100%" flat tile>
    <v-card-actions>
      <h4 class="pl-4 subtitle-2">{{ title }}</h4>
      <v-spacer />
      <v-btn icon @click="showMore = !showMore" v-if="items && items.length">
        <v-icon>{{ showMore ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
      </v-btn>
    </v-card-actions>
    <v-divider />
    <v-expand-transition v-if="items && items.length">
      <div class="grey lighten-4" v-show="showMore">
        <v-card-text>
          <v-text-field
            v-if="searchable"
            v-model="query"
            class="mb-2 white"
            hide-details
            append-icon="mdi-magnify"
            outlined
            dense
            :label="title"
            type="text"
            @input="searchInsideFacet"
          ></v-text-field>
          <div v-if="itemsToShow.length">
            <div
              v-for="item in itemsToShow"
              :key="item.id"
              class="facet-item"
              :class="isChecked(item.id) ? 'facet-item--selected' : ''"
              style="padding: 0.1rem 0.5rem;"
            >
              <label class="d-flex align-center" :title="item.value">
                <input class="mb-1" @click="handlefilter($event, item)" type="checkbox" :checked="isChecked(item.id)" />
                <span v-if="getDefaultValueLabel(item.value)" class="mx-1 ellipsis">{{ getDefaultValueLabel(item.value) }}</span>
                <span v-if="item.from" class="mx-1">{{ item.from }}</span>
                <span v-if="item.from && item.to" class="mx-1">-</span>
                <span v-if="item.to" class="mx-1">{{ item.to }}</span>
                <span class="caption counter ml-auto">{{ item.count }}</span>
              </label>
            </div>
          </div>
          <div v-else class="caption grey--text text--darken-2">
            Aucun résultat trouvé ...
          </div>
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import { globalMixin } from '../../mixins'
import { makeFetchRequest } from '../../utils'

export default {
  mixins: [globalMixin],
  props: {
    elasticSearch: [Object, Array],
    field: String,
    title: String,
    defaultValueLabels: {
      type: Object,
      default: null
    },
    items: Array,
    searchable: Boolean,
    type: String,
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchItems: [],
      query: "",
      showMore: this.show
    }
  },
  computed: {
    itemsToShow() {
      return this.query.trim() !== "" ? this.searchItems : this.items;
    },
    // Use to trigger the watch and perform the search reset inside each facet
    resetSearch() {
      return this.$store.state.resetSearchInsideEachFacet;
    }
  },
  methods: {
    isChecked(id) {
      let filter = this.$store.state.filters.find(f => f.id === id);
      return !!filter
    },
    getDefaultValueLabel(value) {    
      if (!this.defaultValueLabels) return value;
  
      return (value in this.defaultValueLabels) ? this.defaultValueLabels[value] : value;
    },
    handlefilter(event, item) {
      if (event.target.checked) {
        if (this.type === "range") {
          // If is a range type on ES
          this.$store.commit("setFilter", {
            field: this.field,
            from: item.from ? item.from : null, // Budget FACET only type range of checkBox type -> careful
            to: item.to ? item.to : null, // Budget FACET only type range of checkBox type -> careful
            breadcrumbs: this.breadcrumbTitle,
            title: this.title,
            id: item.id,
            type: this.type
          });
        } else {
          this.$store.commit("setFilter", {
            field: this.field,
            value: item.value,
            id: item.id,
            defaultValueLabel: this.getDefaultValueLabel(item.value),
            type: this.type
          });

          // Reset Searchble input to search inside each facet
          this.$store.commit('setResetSearchInsideEachFacet', true);
        }
      } else {
        this.$store.commit("removeFilter", {
          id: item.id
        });
      }
    },
    async searchInsideFacet() {
      if(this.query.trim() !== ""){
        // Get the context
        const body = {
            query: this.query,
            search_fields: { [this.field.replace(".raw", "")]: {  } }, // TODO -> probably change this to json configuration, remove the ".raw" from facet field
            filters: this.handleFilters(this.$store.state.filters),
            facets: [{ elasticSearch: this.elasticSearch }],
            limit: 0,
            sort: null,
            start: 0
        };

        const response = await makeFetchRequest('/api/search', 'POST', body);

        if(response.success){
          this.searchItems = response.data.facets[this.field].data.map(item => {
            return { id: `${this.field}-${item.value || item.from || 'last'}`, ...item } // TODO -> not the perfect solution
          })
        }else {
          console.log("Error: ", response.data)
        }

      }
    }
  },
  watch: {
    // Reset all the search input inside each facet.
    resetSearch(val) {
      if(val){
        this.query = "";
        this.$nextTick(() => {
          this.$store.commit('setResetSearchInsideEachFacet', false);
        })
      }
    },
    showMore() {
      this.$emit('show-changed');
    }
  }
};
</script>
<style lang="scss">
.counter {
  padding: .1rem .4rem;
    font-size: .8rem;
    color: #703a3a;
    background-color: #eedfdf;
    border-radius: 8px;
}
</style>